import React from "react";

const WarningIcon: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polygon
      points="12,2 22,20 2,20"
      stroke="#F9AB00"
      strokeWidth="2"
      fill="none"
    />
    <line x1="12" y1="8" x2="12" y2="14" stroke="#F9AB00" strokeWidth="2" />
    <circle cx="12" cy="17" r="1.5" fill="#F9AB00" />
  </svg>
);

export default WarningIcon;
